import { IValueInputAttachable } from "client/Forms/attachable";
import { never } from "client_legacy/ndaw/errors";
import {
	UserAndUserGroupCollectionMode,
	UserAndUserGroupCollectionProps,
	UserAndUserGroupCollectionValue,
	UserAndUserGroupKind
} from "./UserAndUserGroupCollection";

export function attachToUserAndUserGroupCollection(
	attachable: IValueInputAttachable<UserAndUserGroupCollectionValue | null>,
	mode: AttachableUserAndUserGroupCollectionMode,
	extraAfterChangeHandler?: (newValue: UserAndUserGroupCollectionValue) => void
): Pick<UserAndUserGroupCollectionProps, "value" | "mode"> {
	let propsMode: UserAndUserGroupCollectionMode;

	const value: UserAndUserGroupCollectionValue = attachable.value ?? EMPTY_RECIPIENTS;

	const changeHandler = (newValue: UserAndUserGroupCollectionValue): void => {
		// We spread the current value in case the object holding the userIds/userGroupIds has
		// additional fields
		attachable.reducer
			.setValue({
				...value,
				...newValue
			});

		attachable.validation
			.triggerInputFinished();

		extraAfterChangeHandler?.(newValue);
	};

	switch (mode.kind) {
		case UserAndUserGroupKind.Read:
			propsMode = {
				kind: UserAndUserGroupKind.Read
			};
			break;
		case UserAndUserGroupKind.Edit:
			propsMode = {
				kind: UserAndUserGroupKind.Edit,
				dialogTitleWhenAddingUsersAndUserGroups: mode.dialogTitleWhenAddingUsersAndUserGroups,
				onChange: changeHandler
			};
			break;
		default:
			never(mode);
	}

	return {
		value,
		mode: propsMode
	};
}

export type AttachableUserAndUserGroupCollectionMode = {
	kind: UserAndUserGroupKind.Read;
} | {
	kind: UserAndUserGroupKind.Edit;
	dialogTitleWhenAddingUsersAndUserGroups: string;
};

const EMPTY_RECIPIENTS: UserAndUserGroupCollectionValue = {
	userIds: [],
	userGroupIds: []
};